import { PipelineEnvironment } from '@telespot/domain';
export interface Pipeline {
  id: string;
  names: Record<string, string>;
  environment: PipelineEnvironment;
}

export enum IEnvironment {
  CLOUD = 'cloud',
  EDGE = 'edge',
}
export interface IPipeline {
  readonly id: string;
  name: { [key: string]: string };
  description: { [key: string]: string };
  env: IEnvironment;
}
export interface IProtocolPipeline extends IPipeline {
  protocolPipelineId: string;
  unassigned: boolean;
}
